var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHeart = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333984 4.0914C0.333984 7.33335 3.0136 9.06094 4.97514 10.6073C5.66732 11.1529 6.33398 11.6667 7.00065 11.6667C7.66732 11.6667 8.33398 11.1529 9.02616 10.6073C10.9877 9.06094 13.6673 7.33335 13.6673 4.0914C13.6673 0.849442 10.0005 -1.44969 7.00065 1.66709C4.00076 -1.44969 0.333984 0.849442 0.333984 4.0914Z",
    fill: "url(#paint0_linear_4143_5366)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4143_5366",
    x1: 0.333984,
    y1: 0.189941,
    x2: 11.6829,
    y2: 13.3748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC008C"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHeart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Heart.ec1e8c7e.svg";
export { ForwardRef as ReactComponent };